import React from 'react';
import { BRAND, isMarketGB } from 'src/constants/main';
import { WallboxSelectAC } from './AC/WallboxSelect.AC';
import { WallboxSelectOV } from './OV/WallboxSelect.OV';
import { WallboxSelectAP } from './AP/WallboxSelect.AP';
import { WallboxSelectDS } from './DS/WallboxSelect.DS';
import { WallboxSelectOV as WallboxSelectOV_GB } from './OV/GB/WallboxSelect.OV';
import { WallboxSelectStyled } from './WallboxSelectStyled';
import { SC } from 'src/styles/theme';

export type WallboxSelectProps = SC & {
    isMobile?: boolean;
    generatedIndex?: number;
};

const WallboxSelect = (props: WallboxSelectProps) => {
    if (BRAND === 'AC') return <WallboxSelectAC {...props} />;
    if (BRAND === 'OV') return isMarketGB ? <WallboxSelectOV_GB {...props} /> : <WallboxSelectOV {...props} />;
    if (BRAND === 'AP') return <WallboxSelectAP {...props} />;
    if (BRAND === 'DS') return <WallboxSelectDS {...props} />;
    return <WallboxSelectStyled {...props} />;
};

export default WallboxSelect;
